<template>
  <div class="api-card">
    <div class="api-card__icon">
      <svg v-if="title === 'Customers'" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
        <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else-if="title === 'Transaction Volume'" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17 6H23V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="api-card__content">
      <p class="api-card__label">{{ title }}</p>
      <p class="api-card__value">{{ formattedValue }}</p>
    </div>
  </div>
</template>

<script>
  import { convertToLocale, formatAmountToDollar } from "@/utils/helpers";
  export default {
    name: "ApiClientCard",
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        type: Number,
        required: true,
      },
      valueType: {
        type: String,
        required: true,
      },
      currency: {
        type: String,
        default: "USD",
      },
    },
    computed: {
      formattedValue() {
        if (this.valueType === "Number") {
          return convertToLocale(this.value);
        }
        if (this.valueType === "Money") {
          return formatAmountToDollar(this.value, 2, this.currency);
        }
        return this.value;
      },
    },
    methods: {
      convertToLocale,
      formatAmountToDollar,
    },
  };
</script>
<style lang="scss" scoped>
  .api-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 24px;
    background: #FFFFFF;
    border-radius: 12px;
    border: 1px solid #E2E8F0;
    flex: 1;
    min-width: 200px;
    
    &__icon {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      background: linear-gradient(135deg, #F0F4FF 0%, #E8EEFF 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      
      svg {
        color: #4D84FF;
      }
    }
    
    &__content {
      min-width: 0;
    }
    
    &__label {
      font-size: 13px;
      font-weight: 400;
      color: #64748B;
      margin-bottom: 4px;
    }
    
    &__value {
      font-size: 22px;
      font-weight: 500;
      color: #0F172A;
      letter-spacing: -0.02em;
    }
  }
</style>
